document.getElementById('show-more-database-filters')?.addEventListener('click', function (event) {
  $('.research-tools__search-select[style="display: none;"]').show();
  $(this).parent().hide();
});
